import { memoize, merge } from 'lodash';

import { get } from '../../01-helpers/services/ajax';

const defaultParams = {};

let getCities;

/**
 * @deprecated. This will be deleted in the near future.
 **/
export default getCities = memoize(data => {
    return get(
        '/umbraco/api/OverviewFilter/Geocode',
        {
            // add data to api call
            data: merge({}, defaultParams, data)
        }
    );
});